@if (erzeugungsanlagenImportReport) {
  <table class="logs">
    <tr>
      <td>
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarningsPlusDeletions() === 0) {
          <span
            >
            <img class="smiley-big" src="/assets/westnetz-icons/smileys/picto_smiley_happy.svg">
          </span>
        }
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarningsPlusDeletions() > 0) {
          <span
            >
            <img class="smiley-big" src="/assets/westnetz-icons/smileys/picto_smiley_meh.svg">
          </span>
        }
        @if (!erzeugungsanlagenImportReport?.success) {
          <span>
            <img class="smiley-big" src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
          </span>
        }
      </td>
      <td>
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarningsPlusDeletions() === 0) {
          <span
            data-qa="report-valid">
            Sehr schön, die ausgewählte Datei ist fehlerfrei und kann mit großer Wahrscheinlichkeit importiert werden.
            <p>
              Nichtdestotrotz kann es während des eigentlichen Importvorgangs trotzdem noch zu Fehlern kommen, beispielsweise,
              wenn es zwischenzeitlich Änderungen in der Datenbank gab oder sich Parameter des Leitsystems geändert haben.
            </p>
          </span>
        }
        @if (erzeugungsanlagenImportReport?.success && getNumberOfTransformationWarningsPlusDeletions() > 0) {
          <span
            data-qa="report-warn">
            Die ausgewählte Datei kann zwar importiert werden, es gibt allerdings ein oder mehrere Hinweise zu Werten, die nicht eindeutig sind. Wir empfehlen, die
            entsprechenden Stellen im Excel-Dokument anzupassen oder nach einem erfolgten Import die hier im TNB-Portal gespeicherten Werte
            mit den im Excel-Dokument angemerkten zu vergleichen.
          </span>
        }
        @if (!erzeugungsanlagenImportReport?.success) {
          <span
            data-qa="report-error">
            Leider müssen wir den Import des Dokuments ablehnen, da entweder das gesamte Dokument oder ein oder mehrere der Erzeuger ungültige oder
            unvollständige Daten enthalten. Gehen Sie bitte anhand der folgenden Liste die Fehler in Ihrem
            Excel-Dokument durch und starten den Import nach der Korrektur erneut. Welche Daten beim Import
            erwartet werden, finden Sie in unserer Ausfüllhilfe.
          </span>
        }
      </td>
    </tr>
  </table>
  @if (amountDeletions() > 0) {
    <div data-qa="delta-view">
      <h2>Bitte beachten Sie, dass beim Import auch Daten gelöscht werden</h2>
      <div>
        <h3>Es werden Erzeugungsanlagen gelöscht</h3>
        <table class="logs">
          <tr>
            <td>
              <img data-qa="delta-erzeugungsanlagen-img" class="smiley-small"
                src="/assets/westnetz-icons/smileys/picto_smiley_meh.svg">
              </td>
              <td data-qa="delta-deletable-erzeugungsanlagen">
                Es
                werden {{ amountDeletions() }}
                Erzeugungsanlage(n) inklusive eventuell vorhandener Planwerte gelöscht.
              </td>
            </tr>
          </table>
        </div>
      </div>
    }
    @if (areLogsPresent()) {
      <div data-qa="amount-of-errors">
        <h2 data-qa="error-header">
          <span class="error-count">{{ getNumberOfTransformationErrors() + getNumberOfImportErrors() }}</span>
          Fehler@if (getNumberOfWarnings() > 0) {
          <span> und <span
          class="warning-count">{{ getNumberOfWarnings() }}</span> Auffälligkeit{{ getNumberOfWarnings() > 1 ? 'en' : '' }}</span>
        }
        gefunden
      </h2>
      @if (erzeugungsanlagenImportReport.log.length > 0) {
        <span>
          <hr>
            <table class="logs">
              @for (l of erzeugungsanlagenImportReport.log; track l) {
                <tr>
                  <td>
                    @if (l.type === 'ErrorImportLogItem') {
                      <img class="smiley-small"
                        src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
                      }
                      @if (l.type === 'WarningImportLogItem') {
                        <img class="smiley-small"
                          src="/assets/westnetz-icons/smileys/picto_smiley_meh.svg">
                        }
                      </td>
                      <td>
                        @if (l.type === 'ErrorImportLogItem') {
                          <redispatch-error-importlogitem [errorImportLogItem]="l"
                            >
                        </redispatch-error-importlogitem>
                      }
                      @if (l.type === 'WarningImportLogItem') {
                        <redispatch-warning-importlogitem [warningImportLogItem]="l"
                          >
                        </redispatch-warning-importlogitem>
                      }
                    </td>
                  </tr>
                }
              </table>
            </span>
          }
          @for (t of erzeugungsanlagenImportReport?.transformations | nonEmptyLogFilter; track t) {
            <div
              data-qa="error-detail">
              <hr>
                <h3>Zeile {{ t.originalRow + 1 }}</h3>
                <table class="logs">
                  @for (l of t.log; track l) {
                    <tr>
                      <td>
                        @if (l.type === 'ErrorTransformationLogItem') {
                          <img class="smiley-small"
                            src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
                          }
                          @if (l.type === 'WarningTransformationLogItem') {
                            <img class="smiley-small"
                              src="/assets/westnetz-icons/smileys/picto_smiley_meh.svg">
                            }
                          </td>
                          <td>
                            @if (l.type === 'ErrorTransformationLogItem') {
                              <redispatch-error-transformationlogitem [errorTransformationLogItem]="l"
                                >
                            </redispatch-error-transformationlogitem>
                          }
                          @if (l.type === 'WarningTransformationLogItem') {
                            <redispatch-warning-transformationlogitem [warningTransformationLogItem]="l"
                              >
                            </redispatch-warning-transformationlogitem>
                          }
                        </td>
                      </tr>
                    }
                  </table>
                </div>
              }
            </div>
          }
        }
